import { NgModule } from '@angular/core';
import { MatCommonModule, MatRippleModule } from '@angular/material/core';
import { MatButtonComponent } from './button.component';
import { MatAnchorComponent } from './anchor.component';

@NgModule({
  imports: [MatRippleModule, MatCommonModule],
  exports: [MatButtonComponent, MatAnchorComponent, MatCommonModule],
  declarations: [MatButtonComponent, MatAnchorComponent],
})
export class ButtonModule {}
